import React from 'react';
import { Select } from 'formik-antd';
import './AppealCategorySelect.scss';
import { Category } from '../../../model/Category';
import categoriesIcons from '../../../utils/chooseIcon';

interface AppealCategorySelectProps {
  title: string;
  name: string;
  category: Category[];
}

const AppealCategorySelect = (
  props: AppealCategorySelectProps
): JSX.Element => {
  return (
    <>
      <label>{props.title}</label>
      <Select
        name={props.name}
        placeholder="Выберите из списка"
        className="problemReportSelect"
        optionLabelProp="label"
      >
        {props.category
          .filter((cat) => cat.parent === 0)
          .map((category: Category) => (
            <>
              <Select.Option
                key={category.id}
                label={category.name}
                value={category.id}
              >
                <span className={'category'}>{category.name}</span>
              </Select.Option>
              {props.category
                .filter((subCat) => subCat.parent === category.id)
                .map((subCategory) => (
                  <Select.Option
                    key={subCategory.id}
                    label={subCategory.name}
                    value={subCategory.id}
                  >
                    <span className={'subCategory'}>{subCategory.name}</span>
                  </Select.Option>
                ))}
            </>
          ))}
      </Select>
    </>
  );
};

export default AppealCategorySelect;
